import { React, forwardRef, useState, useRef, useImperativeHandle, useEffect } from 'react';
import styled from 'styled-components';

import SelectOnPath from '../../image/SelectOn.png';
import SelectOffPath from '../../image/SelectOff.png';

const SignUpSelectBox = forwardRef((props, ref) => {
	// const [firstOption, setFirstOption] = useState();
	const [isClicked, setIsClicked] = useState(false);
	const [defaultVal, setDefaultVal] = useState({ value: 'PT', text: '1 : 1 PT' });

	const SelectRef = useRef()

	const options = [
		{ value: 'PT', text: '1 : 1 PT' },
		{ value: 'groupTraining', text: '그룹 트레이닝' },
		{ value: 'boutiqueFitness', text: '부티크 피트니스' },
		{ value: 'normalFitness', text: '일반 피트니스 센터' },
		{ value: 'pilates', text: '필라테스' },
		{ value: 'yoga', text: 'yoga' },
		{ value: 'crossfit', text: '크로스핏' },
		{ value: 'basketball', text: '농구' },
		{ value: 'tennis', text: '테니스' },
		{ value: 'baseball', text: '야구' },
		{ value: 'soccer', text: '축구' },
		{ value: 'spinning', text: '스피닝' },
		{ value: 'ballet', text: '발레' },
		{ value: 'boxing', text: '복싱' },
		{ value: 'dance', text: '댄스' },
		{ value: 'golf', text: '골프' },
		{ value: 'other', text: '기타' },
	];

	useEffect(() => {
		function handleOutsideClick(e) {
			if (!isClicked) return;

			// SelectBox 바깥 클릭이면 닫기
			if (SelectRef.current && !SelectRef.current.contains(e.target)) {
			SelectRef.current.style.border = '1px solid #CBCBCB';
			SelectRef.current.style.height = '34px';
			SelectRef.current.style.overflow = 'hidden';
			setIsClicked(false);
			}
		}

		document.addEventListener('mousedown', handleOutsideClick);

		return () => {
			document.removeEventListener('mousedown', handleOutsideClick);
		};
	}, [isClicked]);

	useImperativeHandle(ref, () => ({
		getValue: (val) => {
			// return defaultVal.value;

			return defaultVal.text;
		}
	}))

	function onClick() {
		if (isClicked) {
			SelectRef.current.style.border = '1px solid #CBCBCB';
			SelectRef.current.style.height = `40px`;
			// SelectRef.current.style.height = firstOption;
			SelectRef.current.style.overflow = 'hidden';
			setIsClicked(false);
		}
		else {
			// setFirstOption(SelectRef.current.style.height);
			SelectRef.current.style.border = '1px solid #FF8B48';
			SelectRef.current.style.height = `240px`;
			SelectRef.current.style.overflowY = 'scroll';
			SelectRef.current.style.overflowX = 'none';
			setIsClicked(true);
		}
	}

	function optionalClick(index) {
		setDefaultVal(options[index]);
	}

	return (
		<TopLevelWrapper>
			<SelectBox
				ref={SelectRef}
				isClicked={isClicked}
				buttonPath={isClicked ? SelectOnPath : SelectOffPath}
				onClick={onClick}>
				{
					isClicked ?
						options.map((data, index) =>
							<OptionWrapper key={index} onClick={() => optionalClick(index)}>
								{/* <Option>{data.value}</Option> */}
								<Option isSelected={data.value === defaultVal.value && data.text === defaultVal.text}>{data.text}</Option>
							</OptionWrapper>
						)
						:
						<OptionWrapper>
							<Option>
								{
									// defaultVal.value
									defaultVal.text
								}
							</Option>
						</OptionWrapper>
				}
			</SelectBox>
		</TopLevelWrapper>
	)
})

export default SignUpSelectBox;

const TopLevelWrapper = styled.div`
	display: flex;
	flex-direction: column;
	
	width: 200px;
	height: 34px;
	// height: max(32px, 1.979166666666667vw);

	margin-top: 10px;
	// margin-top: max(12.27px, 0.6770833333333333vw);
`;

const SelectBox = styled.div`
	position: absolute;
	display: flex;
	flex-direction: column;

	justify-content: ${props => props.isClicked ? 'flex-start' : 'center'};
	align-items: flex-start;

	width: 200px;
	height: 34px;
	// height: max(32px, 1.979166666666667vw);

	border: 1px solid #777777;
	border-radius: 8px;
	overflow: hidden;

	z-index: 2;

  background: url(${props => props.buttonPath}) no-repeat 96% ${props => props.isClicked ? `3` : `55`}%;
	background-color: rgba(255, 255, 255, 1);
  transition: all 0.3s ease-in-out;

	&:hover {
		cursor: pointer;
	}

	&::-webkit-scrollbar {
		width: 9px;
	}

	&::-webkit-scrollbar-thumb {
    box-shadow: inset 0 0 10px 20px #FF8B48;
		border: 3px solid transparent;
		height: 25px;
		// background-color: #FF8B48;
		border-radius: 200px;
	}

	&::-webkit-scrollbar-track {
    box-shadow: inset 0 0 10px 10px transparent;
		border: 4px solid transparent;
		background-color: transparent;
	}

	&::-webkit-scrollbar-track-piece {
		background-color: transparent;
	}
`;

const OptionWrapper = styled.div`
	display: flex;
	flex-direction: column;
	width: 100%;

	&:hover {
		cursor: pointer;
	}
`;

const Option = styled.p`
	font-family: NotoSansKR-Regular;
	font-size: 16px;
	// font-size: max(12px, 0.7291666666666667vw);
	margin: 10px 0 10px 13px;
	// margin-top: max(6px, 0.5208333333333333vw);
	// margin-right: 0px;
	// margin-bottom: max(9px, 0.5208333333333333vw);
	// margin-left: max(12px, 0.6770833333333333vw);

	color: ${props => props.isSelected ? '#FF8B48' : '#333333'};
`;